export default __webpack_public_path__ + "static/media/live.29008510.svg";